import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

const ProfileTitle = (props) => {
  const onSubmitTitle = props.onSubmitTitle;
  const [title, setTitle] = useState(props.title || "");
  const [editing, setEditing] = useState(false);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {!editing && (
        <>
          {props.title ? (
            <h5 style={{ margin: "0px" }}>{props.title}</h5>
          ) : (
            <h5 style={{ margin: "0px" }}>No title...</h5>
          )}
          <IconButton
            onClick={() => {
              setTitle(props.title || "");
              setEditing(true);
            }}
            variant="outlined"
            color="primary"
            size="small"
            style={{ marginLeft: "5px" }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </>
      )}
      {editing && (
        <form
          onSubmit={(e) => {
            setEditing(false);
            onSubmitTitle(e, title);
          }}
          style={{ display: "flex", alignItems: "center" }}
        >
          <TextField
            type="text"
            name="title"
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="form-cotrol"
            variant="outlined"
            size="small"
            placeholder="Enter a title"
          />
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            style={{ margin: "0px 5px" }}
          >
            Save
          </Button>
          <Button
            onClick={() => setEditing(false)}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </Button>
        </form>
      )}
    </div>
  );
};

export default ProfileTitle;
